import { api } from './api';
import { entriesSetState } from '../containers/contentSlice';

export interface UpdateCurrentCompanyRequest {
	name: string;
}

export interface CompanyResponse {
	id: number;
	name: string;
}

export interface ResetWorkspaceResponse {
	records: unknown;
	repositories: unknown;
}

export const companiesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		updateCurrentCompany: builder.mutation<CompanyResponse, UpdateCurrentCompanyRequest>({
			query: (body) => ({
				url: 'companies/current',
				method: 'PUT',
				body,
			}),
			extraOptions: { maxRetries: 1 },
		}),
		resetWorkspace: builder.mutation<ResetWorkspaceResponse, void>({
			query: () => ({
				url: 'companies/resetWorkspace',
				method: 'DELETE',
			}),
			extraOptions: { maxRetries: 0 },
			async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
				try {
					await queryFulfilled;
					dispatch(entriesSetState([]));
					dispatch(
						api.util.invalidateTags([
							'Repositories',
							'Repository',
							'RepositoryEntries',
							'RepositoryEntry',
							'RepositoryEntryCount',
							'Notes',
							'References',
						]),
					);
				} catch {
					// leave local state unchanged on failure
				}
			},
		}),
	}),
});

export const {
	useUpdateCurrentCompanyMutation,
	useResetWorkspaceMutation,
} = companiesApi;
